import { createTheme, ThemeOptions } from "@mui/material/styles";
declare module "@mui/material/styles" {
  interface Palette {
    star: {
      empty: string;
      filled: string;
    };
    border: {
      primary?: string;
    };
  }

  interface PaletteOptions {
    star?: {
      empty?: string;
      filled?: string;
    };
    border?: {
      primary?: string;
    };
  }
}

export const nblyThemeData: ThemeOptions = {
  palette: {
    primary: {
      main: "#3A73B7",
      light: "#F3F4F6",
      dark: "#3A73B7",
    },
    secondary: {
      main: "#3A73B7",
      light: "#F3F4F6",
    },
    background: {
      default: "#F3F4F6",
      paper: "#F3F4F6",
    },
    star: {
      empty: "#D1D5DB",
      filled: "#e6d130",
    },
    text: {
      primary: "#000000",
      secondary: "#3A73B7",
      disabled: "grey",
    },
    warning: {
      main: "#3A73B7",
    },
    action: {
      disabled: "#9e9e9e",
    },
    border: {
      primary: "#3A73B7",
    },
  },
  typography: {
    fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
    h1: {
      fontSize: "2.25rem",
      fontWeight: 700,
      marginBottom: "1.5rem",
      color: "#3A73B7",
      textAlign: "center",
    },
    h2: {
      fontSize: "1.875rem",
      fontWeight: 700,
      marginBottom: "1.5rem",
      color: "#1B3554",
    },
    h3: {
      fontSize: "1.5rem",
      fontWeight: 700,
      marginBottom: "1rem",
      color: "#3A73B7",
    },
    h4: {
      fontSize: "1rem",
      fontWeight: "bold",
      color: "#000000",
      textAlign: "left",
      marginTop: "1em",
      marginBottom: "1em",
    },
    h6: {
      fontSize: "0.8rem",
      fontWeight: "bold",
      color: "#000000",
    },
    caption: {
      fontSize: "0.8rem",
      fontWeight: "bold",
      color: "#3A73B7",
      textAlign: "left",
    },
    body1: {
      fontSize: "0.8rem",
      color: "#000000",
      arrowIconColor: "#FFFFFF", //for arrow in button
      priceQuoteBackground: "#F9FAFB",
      detailsTextColor: "#111928",
      checkBoxBackground: "#f3f4f6",
      descriptionTextColor: "#6b7280",
      ndrpSectionBackground: "#f9fafa",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#3A73B7",
          borderRadius: "0.5rem",
          "&:hover": {
            backgroundColor: "#3A73B7",
          },
          color: "#FFFFFF",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: "rgb(107 114 128)",
          fill: "#43b02a",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          color: "#3A73B7",
          "&:hover": {
            color: "#3A73B7",
          },
          width: "1.5rem",
          height: "1.5rem",
          "&.Mui-disabled": {
            color: "#9e9e9e",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: "rgb(17 24 39)",
          fontSize: "1rem",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
        },
      },
    },
  },
};

export const nblyTheme = createTheme(nblyThemeData);
